import { Component, Input } from '@angular/core';
import { FacetListComponent } from '@spartacus/storefront';
import { DEVICE_SIZE } from '../../../../../../core/models/others.model';

@Component({
  selector: 'cx-facet-list',
  templateUrl: './facet-list.component.html',
  styleUrl: './facet-list.component.scss',
  standalone: false,
})
export class CustomFacetListComponent extends FacetListComponent {
  @Input() classContainer = '';

  DEVICE_SIZE = DEVICE_SIZE;
}
